function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_advancedsignup:customdeploy_ns_sc_ext_sl_advancedsignup":"/app/site/hosting/scriptlet.nl?script=389&deploy=1&compid=6724102&ns-at=AAEJ7tMQU4HGsZ5cVevUYjTJisc1FpIYxgnL-oSGMa3Fscga-zk","customscript_ns_sc_ext_sl_orderstatus_of:customdeploy_ns_sc_ext_sl_orderstatus_of":"/app/site/hosting/scriptlet.nl?script=373&deploy=1&compid=6724102&ns-at=AAEJ7tMQAte7zR8XfewK2uDdW3EkPQsQuql1fh6CRuGyRMZeViQ","customscript_ns_sc_ext_sl_sn_sub:customdeploy_create_subscription":"/app/site/hosting/scriptlet.nl?script=1494&deploy=1&compid=6724102&ns-at=AAEJ7tMQhaYrOiXCsaMSTbUOPOl3XwlyX9VjBwIsaRjGHMv4f5s","customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=49&deploy=1&compid=6724102&ns-at=AAEJ7tMQ7Hi2_tbaoRpFm1yW2Ab0WlHFK0AA2sE45rFG6uSbPNg","customscript_ns_sc_sl_id_isb:customdeploy_ns_sc_sl_id_isb":"/app/site/hosting/scriptlet.nl?script=1696&deploy=1&compid=6724102&ns-at=AAEJ7tMQofA5OsF1Tur0IsdNRJsfFCuVbyjPHIsojaHo8VjPq2o","customscript_ns_sc_sl_inventory_display:customdeploy_ns_sc_sl_inventory_display":"/app/site/hosting/scriptlet.nl?script=54&deploy=1&compid=6724102&ns-at=AAEJ7tMQNWRI9zLfMYou9xGmmOuZ7hFT7EUB3Ixts1FlwJtj6sM","customscript_ns_sc_sl_itembadges:customdeploy_ns_sc_sl_itembadges":"/app/site/hosting/scriptlet.nl?script=56&deploy=1&compid=6724102&ns-at=AAEJ7tMQUp3b1_LORqrWDs53n813gXVTknK1ctRhAlOGB5Rvhsw","customscript_ns_sc_sl_sn_get_subs:customdeploy_ns_sc_sl_sn_get_subs":"/app/site/hosting/scriptlet.nl?script=1493&deploy=1&compid=6724102&ns-at=AAEJ7tMQPxnt-R_wbsAOImiel9FFNjdR1smklDFijp9Dj4m-rp0","customscript_ns_sc_sl_sn_isb:customdeploy_ns_sc_sl_sn_isb":"/app/site/hosting/scriptlet.nl?script=1695&deploy=1&compid=6724102&ns-at=AAEJ7tMQkgqpK2QwgFOPEjwg-sl2pDD1QRfSGsADOYU5692wOQY","customscript_ns_sc_sl_sn_subswitch:customdeploy_ns_sc_sl_sn_subswitch":"/app/site/hosting/scriptlet.nl?script=1492&deploy=1&compid=6724102&ns-at=AAEJ7tMQIIsi8uR_02iCXPf-t6057nIJH9pfnHgHW9AOUzI0N9c"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}